module.exports = __webpack_public_path__ + "static/media/banner1.59fba48d.jpg";